import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=5031b956&scoped=true&"
import script from "./Stats.vue?vue&type=script&lang=js&"
export * from "./Stats.vue?vue&type=script&lang=js&"
import style0 from "./Stats.vue?vue&type=style&index=0&id=5031b956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5031b956",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/timefly-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5031b956')) {
      api.createRecord('5031b956', component.options)
    } else {
      api.reload('5031b956', component.options)
    }
    module.hot.accept("./Stats.vue?vue&type=template&id=5031b956&scoped=true&", function () {
      api.rerender('5031b956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Stats.vue"
export default component.exports